import { featureFlags } from '@lib/constants/network-constants';
import { getFeatureFlagState } from '@lib/data';
import { useEffect, useState } from 'react';
import { getLogger } from '@lib/util/logging-util';

const logger = getLogger();

declare const TTDUniversalPixelApi: any;

const ADVERTISER_ID = 'mlwqkdr';
const PIXEL_IDS = ["wpfyrti"];
const TRADE_DESK_LOADER_URL = 'https://js.adsrvr.org/up_loader.1.1.0.js';
const TRADE_DESK_TRACK_UP_URL = 'https://insight.adsrvr.org/track/up';
const ADROLL_ADV_ID = 'IJU7A5PFOJHHFAUB3JREFW';
const ADROLL_PIX_ID = 'IFT6RHFAOJGRZMTC24CXO7';

const checkYelpPixelEnabled = async (): Promise<boolean> => {
  try {
    return await getFeatureFlagState(featureFlags.YELP_PIXEL);
  } catch (error) {
    logger.error("Error checking Yelp Pixel state:", error);
    return false;
  }
};

const checkExistingAdRollPixelScripts =  () => {
  const existingScripts = document.querySelectorAll('script[adroll*="adrolllib.com"]');
  if (existingScripts && existingScripts.length > 0) return true;
  return false;
};

const appendAdrollScript = () => {
  const tradeDeskScript = document.createElement('script');
  tradeDeskScript.setAttribute('adroll', 'adrolllib.com');
  tradeDeskScript.src = TRADE_DESK_LOADER_URL;
  tradeDeskScript.async = true;

  tradeDeskScript.onload = () => {
    if (typeof TTDUniversalPixelApi === 'function') {
      const universalPixelApi = new TTDUniversalPixelApi();
      universalPixelApi.init(ADVERTISER_ID, PIXEL_IDS, TRADE_DESK_TRACK_UP_URL);
    } else {
      logger.error("TTDUniversalPixelApi is not defined");
    }
  };

  document.head.appendChild(tradeDeskScript);

  const adrollScript = document.createElement('script');
  adrollScript.setAttribute('adroll', 'adrolllib.com');
  adrollScript.type = 'text/javascript';
  adrollScript.innerHTML = `
    adroll_adv_id = "${ADROLL_ADV_ID}";
    adroll_pix_id = "${ADROLL_PIX_ID}";
    adroll_version = "2.0";
    (function(w, d, e, o, a) {
      w.__adroll_loaded = true;
      w.adroll = w.adroll || [];
      w.adroll.f = [ 'setProperties', 'identify', 'track', 'identify_email' ];
      var roundtripUrl = "https://s.adroll.com/j/" + adroll_adv_id + "/roundtrip.js";
      for (a = 0; a < w.adroll.f.length; a++) {
        w.adroll[w.adroll.f[a]] = w.adroll[w.adroll.f[a]] || (function(n) {
          return function() {
            w.adroll.push([ n, arguments ])
          }
        })(w.adroll.f[a])
      }
      e = d.createElement('script');
      o = d.getElementsByTagName('script')[0];
      e.async = 1;
      e.src = roundtripUrl;
      o.parentNode.insertBefore(e, o);
    })(window, document);
    adroll.track("pageView");
  `;

  document.head.appendChild(adrollScript);
}

const TTDPixel = () => {
  useEffect(() => {
    const initializePixels = async () => {
      const enabled = await checkYelpPixelEnabled();
      if (!enabled) return;

      appendAdrollScript();
    }

    if (checkExistingAdRollPixelScripts()) return;

    initializePixels();
  }, []);
};

export const PixelImg = (params: any) => {
  const [enabled, setEnabled] = useState<boolean>(false);

  useEffect(() => {
    const checkEnabled = async () => {
      setEnabled(await checkYelpPixelEnabled());
    };
    checkEnabled();
  }, []);

  if (!enabled) return null;

  return (
    <img height='1' width='1' style={{borderStyle:'none'}} alt='' src={`https://insight.adsrvr.org/track/pxl/?adv=${ADVERTISER_ID}&${params.src}`}/>
  );
}

export const GenerateAdRollScript = async (params: any) => {
  if (typeof document !== 'undefined') {
    const existingScripts = document.querySelectorAll('script[adroll*="adroll.com"]');
    existingScripts.forEach(script => script.remove());

    const enabled = await checkYelpPixelEnabled();
    if (!enabled) return;

    if(!checkExistingAdRollPixelScripts()) {
      appendAdrollScript();
    }

    const script = document.createElement('script');
    script.setAttribute('adroll', 'adroll.com');
    let scriptParams = `segment_name: "${params.segment_name}"`;
    if (params.order_id && params.corversion_value) {
      scriptParams += `,
            order_id: "${params.order_id}",
            conversion_value: "${params.corversion_value}",
            currency: "USD"`;
    }
    script.innerHTML = `
      try {
        if (typeof adroll !== 'undefined') {
          const trackingParams = {
            ${scriptParams}
          };
          adroll.track("pageView", trackingParams);
        } else {
          console.error("adroll is not defined");
        }
      } catch (err) {
        console.error("Error tracking AdRoll pageView:", err);
      }
    `;
    document.body.appendChild(script);
  }
};

export default TTDPixel;
